export default __webpack_public_path__ + "static/media/CardFilterType.1aae1386.svg";